import { render, staticRenderFns } from "./PageSandbox.vue?vue&type=template&id=09a19d28&"
import script from "./PageSandbox.vue?vue&type=script&lang=js&"
export * from "./PageSandbox.vue?vue&type=script&lang=js&"
import style0 from "./PageSandbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports